import { useTranslation } from 'react-i18next';
import { brands } from '@/mocks/articles';

const brandImages: Record<string, string> = {
  'brand-nike-01': 'https://readdy.ai/api/search-image?query=Nike%20Air%20Max%20sneakers%20in%20white%20and%20red%20on%20warm%20concrete%20surface%20with%20sunlight%20streaks%2C%20dynamic%20editorial%20product%20photography%2C%20clean%20modern%20aesthetic%20with%20urban%20texture&width=800&height=500&seq=brand-nike-v2&orientation=landscape',
  'brand-adidas-02': 'https://readdy.ai/api/search-image?query=Adidas%20Stan%20Smith%20white%20green%20trainers%20on%20light%20oak%20parquet%20floor%2C%20soft%20afternoon%20sunlight%2C%20minimal%20editorial%20product%20photography%2C%20clean%20sporty%20composition&width=800&height=500&seq=brand-adidas-v2&orientation=landscape',
  'brand-essentials-03': 'https://readdy.ai/api/search-image?query=Fear%20of%20God%20Essentials%20charcoal%20grey%20hoodie%20on%20cream%20linen%20backdrop%2C%20soft%20diffused%20studio%20lighting%2C%20minimal%20editorial%20fashion%20photography%2C%20premium%20aesthetic&width=800&height=500&seq=brand-essentials-v2&orientation=landscape',
  'brand-trapstar-04': 'https://readdy.ai/api/search-image?query=Trapstar%20black%20graphic%20jacket%20with%20red%20logo%20on%20warm%20grey%20backdrop%2C%20bold%20editorial%20streetwear%20photography%2C%20dramatic%20side%20lighting%2C%20urban%20edge%20aesthetic&width=800&height=500&seq=brand-trapstar-v2&orientation=landscape',
  'brand-yeezy-05': 'https://readdy.ai/api/search-image?query=Yeezy%20350%20cream%20white%20sneakers%20on%20warm%20desert%20sand%20textured%20surface%2C%20soft%20golden%20hour%20light%2C%20minimal%20editorial%20product%20photography%2C%20organic%20earth%20tone%20aesthetic&width=800&height=500&seq=brand-yeezy-v2&orientation=landscape',
  'brand-jordan-06': 'https://readdy.ai/api/search-image?query=Jordan%201%20High%20banned%20colorway%20on%20warm%20cement%20textured%20surface%2C%20soft%20overhead%20studio%20light%2C%20minimal%20editorial%20sneaker%20photography%2C%20classic%20basketball%20aesthetic&width=800&height=500&seq=brand-jordan-v2&orientation=landscape',
  'brand-stussy-07': 'https://readdy.ai/api/search-image?query=Stussy%20white%20graphic%20t-shirt%20on%20warm%20terracotta%20surface%2C%20soft%20natural%20light%20from%20window%2C%20minimal%20editorial%20streetwear%20photography%2C%20surf%20skate%20aesthetic&width=800&height=500&seq=brand-stussy-v2&orientation=landscape',
  'brand-supreme-08': 'https://readdy.ai/api/search-image?query=Supreme%20red%20box%20logo%20beanie%20on%20light%20grey%20marble%20surface%2C%20soft%20dramatic%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20iconic%20streetwear%20aesthetic&width=800&height=500&seq=brand-supreme-v2&orientation=landscape',
  'brand-nb-09': 'https://readdy.ai/api/search-image?query=New%20Balance%20990%20grey%20suede%20sneakers%20on%20warm%20oatmeal%20textured%20backdrop%2C%20soft%20morning%20light%2C%20minimal%20editorial%20product%20photography%2C%20dad%20shoe%20premium%20aesthetic&width=800&height=500&seq=brand-nb-v2&orientation=landscape',
  'brand-si-10': 'https://readdy.ai/api/search-image?query=Stone%20Island%20navy%20compass%20badge%20jacket%20on%20warm%20beige%20linen%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20fashion%20photography%2C%20technical%20premium%20aesthetic&width=800&height=500&seq=brand-si-v2&orientation=landscape',
};

export default function BrandGrid() {
  const { t } = useTranslation('home');

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            {t('brands_title')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base font-body">
            {t('brands_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {brands.map((brand, index) => (
            <div
              key={brand.seq}
              className="group rounded-2xl overflow-hidden bg-background-100/70 border border-background-200/50 hover:border-primary-200/60 transition-all duration-300 flex flex-col"
            >
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={brandImages[brand.seq]}
                  alt={`${brand.name} Kakobuy`}
                  title={`${brand.name} - Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              </div>

              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2 text-center">
                  {brand.name}
                </h3>
                <p className="text-foreground-400 text-sm text-center mb-4 font-body">
                  Arkusz produktowy {brand.name.split(' ')[0]}
                </p>

                <div className="mt-auto">
                  {index === 0 ? (
                    <a
                      href="https://kaspreadsheet.com/"
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-center w-full px-5 py-2.5 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 font-label font-medium text-sm whitespace-nowrap cursor-pointer"
                    >
                      Zobacz arkusz <i className="ri-arrow-right-up-line ml-1 text-xs"></i>
                    </a>
                  ) : (
                    <a
                      href="https://kaspreadsheet.com/"
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-center w-full px-5 py-2.5 border-2 border-foreground-900 text-foreground-900 rounded-full hover:bg-foreground-900 hover:text-background-50 transition-colors duration-200 font-label font-medium text-sm whitespace-nowrap cursor-pointer"
                    >
                      Zobacz arkusz <i className="ri-arrow-right-up-line ml-1 text-xs"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}